import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import DatePicker from 'Components/Atoms/DatePicker/DatePicker';

export default function RHFDatePicker({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => <DatePicker {...field} error={error?.message} {...other} />}
        />
    );
}

RHFDatePicker.propTypes = {
    name: PropTypes.string,
};
